import Form from "./Form";
import { useTranslation } from "react-i18next";

export default function SendAnAlert() {
  const { t } = useTranslation();
  return (
    <div className="container mb-8">
      <div className="ui-card mb-4 md:mb-6 p-4 xl:p-6">
        <div className="md:flex-grow ">
          <h2 className="mb-2 text-xl font-body font-bold">
            {t("AgentCSR-Admin-SendAnAlert-title")}
          </h2>
          <p>{t("AgentCSR-Admin-SendAnAlert-discription")}</p>
          <hr />
        </div>

        <Form />
      </div>
    </div>
  );
}
